<mat-card fxFlex>
  <mat-card-title>
    Sugestões
  </mat-card-title>

  <mat-card-content>
    <div fxLayout="column" fxLayoutAlign="space-between" id="accordion">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">
        <!-- message Column -->
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef> Mensagem </th>
          <td mat-cell *matCellDef="let element; let i = index;"  style="border: solid 1px #B8B8B8; border-right:none; border-left:none">
            <form [formGroup]="formSuggestionAnswer[i]" class="margeTop" style="margin-bottom:30px">
              <div class="color-escritha" style="font-size:14px; margin-top:4px">
                <b>{{element.user.name}}</b>
                <i style="font-size:11px">{{element.created_at}}</i>
              </div> 
              <div>
                {{element.message}}
              </div>
              <div *ngFor="let sugg_answer of element.suggestions_answers">
                <div class={{sugg_answer.color}} style="font-size:14px; margin-top:12px;">
                  <b>{{sugg_answer.user.name}}</b>
                  <i style="font-size:11px">{{sugg_answer.created_at}}</i>
                </div>
                <div>
                  {{sugg_answer.message}}
                </div>
              </div>
              <div *ngIf = "element.reply">
                <div id="headingTwo" style="margin-bottom:6px">
                  <a data-toggle="collapse" href="#collapseAnswer{{element.id}}" role="button" 
                    aria-expanded="false" aria-controls="collapseAnswer{{element.id}}" style="font-size:12px">  
                    Responder
                  </a>
                </div>
                <div class="collapse" id="collapseAnswer{{element.id}}"  aria-labelledby="headingTwo" data-parent="#accordion">
                  <textarea style="width:80%" formControlName="answer"></textarea>
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-primary btn-sm background-escritha" style="margin-right:20%; margin-bottom:5px"
                    (click) = "saveAnswer(i, element.id)">Salvar</button>
                  </div>
                </div>
              </div>
            </form>
          </td>
        </ng-container>

        <!-- public Column -->
        <ng-container matColumnDef="public">
          <th mat-header-cell *matHeaderCellDef> 
            <button type="button" class="btn btn-link" (click)="this.getSuggestions({ previousPageIndex: 0, pageIndex: this.page.current_page, pageSize: this.page.per_page, length: this.page.totalElements });" style="margin-left:60%">
              <i class="fas fa-redo" style="color:#A9A9A9"></i>
            </button> 
          </th>
          <td mat-cell *matCellDef="let element; let i = index" style="border: solid 1px #B8B8B8; border-right:none; border-left:none"> 
            <div class="form-check d-flex justify-content-center" *ngIf="element.public"
            style="font-size:12px; color:#A8A8A8">
                Público
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <br>

      <mat-paginator
        fxLayoutAlign="end end"
        [length]="page.totalElements"
        [pageSize]="page.per_page"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="page.current_page"
        showFirstLastButtons
        (page)="pageEvent = getSuggestions($event)"
      ></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
